import { OperationType, OperationTypeStr } from '@common/enums';

type Value = {
  displayName: string;
  operationType: OperationType;
};

export const OperationTypeByAPIMap: Record<OperationTypeStr, Value> = {
  [OperationTypeStr.Archive]: {
    displayName: 'Archive',
    operationType: OperationType.Archive
  },
  [OperationTypeStr.Backup]: {
    displayName: 'Backup',
    operationType: OperationType.Backup
  },
  [OperationTypeStr.CalculateUsersProviderSize]: {
    displayName: 'Calculate Users Size',
    operationType: OperationType.CalculateUsersProviderSize
  },
  [OperationTypeStr.ClearCustomer]: {
    displayName: 'Clearing customer data',
    operationType: OperationType.ClearCustomer
  },
  [OperationTypeStr.DeleteFromStorage]: {
    displayName: 'Deleting data',
    operationType: OperationType.DeleteFromStorage
  },
  [OperationTypeStr.DeleteItems]: {
    displayName: 'Deleting items',
    operationType: OperationType.DeleteItems
  },
  [OperationTypeStr.DeleteUser]: {
    displayName: 'Deleting user',
    operationType: OperationType.DeleteUser
  },
  [OperationTypeStr.Export]: {
    displayName: 'Export',
    operationType: OperationType.Export
  },
  [OperationTypeStr.MarkingForDelete]: {
    displayName: 'Flagging for deletion',
    operationType: OperationType.MarkingForDelete
  },
  [OperationTypeStr.None]: {
    displayName: 'None',
    operationType: OperationType.None
  },
  [OperationTypeStr.ProcessRetention]: {
    displayName: 'Retention policy',
    operationType: OperationType.ProcessRetention
  },
  [OperationTypeStr.Restore]: {
    displayName: 'Restore',
    operationType: OperationType.Restore
  },
  [OperationTypeStr.Sync]: {
    displayName: 'Sync',
    operationType: OperationType.Sync
  },
  [OperationTypeStr.Test]: {
    displayName: '',
    operationType: OperationType.Test
  }
};
